// extracted by mini-css-extract-plugin
export var entityChip = "_s7-0";
export var entityChipMissing = "_s7-1";